import axios from 'axios';

export const config = {
  //LIVE
  baseURL: 'https://api.superjetom.com',
  redirectURL: 'https://superjetom.com',
  sanadURL: 'https://www.smartforms.com.om/smartformsonline/BrandingCSS/branding.js',
  amwalpayURL: 'https://checkout.amwalpg.com/js/SmartBox.js?v=1.1'

  //UAT
  // baseURL: 'https://stg-api.superjetom.com',
  // redirectURL: 'https://uat.superjetom.com',
  // sanadURL: 'https://sanad.superjetom.com/branding.js',
  // amwalpayURL: 'https://test.amwalpg.com:7443/js/SmartBox.js?v=1.1'

  //LOCAL
  // baseURL: 'http://127.0.0.1:3000',
  // redirectURL:'http://localhost:3001',
  // sanadURL: 'https://sanad.superjetom.com/branding.js',
  // amwalpayURL: 'https://test.amwalpg.com:7443/js/SmartBox.js?v=1.1'
  // redirectURL:'http://192.168.29.115:3001'
};

export const endPoints = {
  signUp: '/create_traveller',
  signUpAgency: '/create_travel_agency',
  loginEndpoint: '/login_traveller',
  loginAgencyEndpoint: '/login_travel_agency',
  loginAgencystaffEndpoint: '/check_agency_staff_login',
  countryList: '/country',
  testApplication: '/create_order_existing_traveller',
  visaPrograms: '/get_visa_programs',
  confirmpassword: '/',
  };

// export const Keys = {
//   gdprApiToken: 'J6WDf0ttQKGfYhQkRCjwraBS11JYuIDx',
//   apiPlatformValueiOS: '3',
//   apiPlatformValueAndroid: '2',
// };

export const axiosClient = axios.create({
  baseURL: config.baseURL,
});

export const getApiInterfaceWithToken = token => {
  return axios.create({
    baseURL: config.baseURL,

    // timeout: 10000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getApiInterface = () => {
  axiosClient.defaults.baseURL = config.baseURL;
  return axiosClient;
};

axiosClient.defaults.timeout = 10000;